import React from 'react';
import Partners from '../components/Partners';
import HeroSection from './HeroSection';
import HomeSection1 from './HomeSection1';


function Home() {
  return (


    <main>

      <Partners />
      <HeroSection />
      <HomeSection1/>

    </main>
  );
}

export default Home;